import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_DOCUMENT_TYPES
} from "./actionTypes"

import {
  getDocumentTypesSuccess,
  documentTypeApiError
} from "./actions"

import {
  getDocumentTypesList
} from "../../helpers/backend_helper/backend_helper"

function* fetchDocumentTypes() {
  try {
    const response = yield call(getDocumentTypesList)
    yield put(getDocumentTypesSuccess(response))
  } catch (error) {
    yield put(documentTypeApiError(error))
  }
}

function* documentTypeManagementSaga() {
  yield takeEvery(GET_DOCUMENT_TYPES,fetchDocumentTypes)
}

export default documentTypeManagementSaga